import React from 'react';
import { get } from 'lodash';

class ListItemThongKeThanhTraXayDungCoBan extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {}
  }

  render() {
    let Item = this.props.item || {};
    return (
      <tr className={`${typeof this.props.item === 'undefined' ? 'row-set-height' : ''} ${this.props.sum ? 'txt-bold' : ''}`}>
        <td className='column-stt-fixed txt-bold'>{this.props.count}</td>
        <td className='column-stt-fixed'>{get(Item, 'model.name')}</td>
        {get(Item, 'statistics').map((item) => (
          <td className="txt-center">{item}</td>
        ))}
      </tr>
    );
  }
}

export default ListItemThongKeThanhTraXayDungCoBan;



// WEBPACK FOOTER //
// ./src/components/modules/thong-ke-bao-cao/datatable/ListItemThongKeThanhTraXayDungCoBan.jsx